import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-terms-content',
    templateUrl: './terms-content.component.html',
    styleUrls: ['./terms-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
